export const waitForApiIdle = async (timeoutMs = 1800) => {
  if (typeof window === "undefined") return;
  const deadline = Date.now() + timeoutMs;
  while (Date.now() < deadline) {
    const apiPending = Number(window.__m11ApiPending || 0);
    const authPending = window.__m11AuthBootstrapPending === true;
    if (apiPending === 0 && !authPending) break;
    await new Promise((resolve) => window.setTimeout(resolve, 50));
  }
};

export const performFullReload = async () => {
  if (typeof window === "undefined" || window.__m11Reloading) return;
  window.__m11Reloading = true;
  await waitForApiIdle();

  // Allow completed request callbacks and telemetry to flush before navigation.
  await new Promise((resolve) => window.setTimeout(resolve, 180));
  window.location.reload();
};